module.exports = __webpack_public_path__ + "img/task-7-g.6969966f.png";